import { Component, Input, Output, EventEmitter, OnInit, SimpleChanges } from '@angular/core';
import SwiperCore, { Mousewheel } from 'swiper';
SwiperCore.use([Mousewheel]);

@Component({
  selector: 'app-number-picker',
  templateUrl: './number-picker.component.html',
  styleUrls: ['./number-picker.component.scss']
})
export class NumberPickerComponent implements OnInit {
  @Input() min: number = 0;
  @Input() max: number = 100;
  @Input() step: number = 5;

  @Output() valueChange = new EventEmitter<number>();

  private _value: number | null = null;
  @Input()
  get value(): number | null {
    return this._value;
  }
  set value(val: number | null) {
    this._value = val;
  }

  numberList: number[] = [];
  swiperInstance: any;

  ngOnInit() {
    this.generateNumberList();

    // Only set a default if parent didn't provide a value
    if ((this.value === undefined || this.value === null) && this.numberList.length) {
      this._value = this.numberList[Math.floor(this.numberList.length / 2)];
      Promise.resolve().then(() => this.valueChange.emit(this._value)); // async to avoid ExpressionChanged error
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] && this.swiperInstance) {
      const newVal = changes['value'].currentValue;
      const indexToSlide = this.numberList.findIndex(num => num === newVal);
      if (indexToSlide >= 0) {
        this.swiperInstance.slideTo(indexToSlide, 0); // update swiper position
      }
    }
  }
  
  generateNumberList() {
  this.numberList = [];
  const decimals = this.step.toString().includes('.') ? this.step.toString().split('.')[1].length : 0;

  for (let i = this.min; i <= this.max; i += this.step) {
    // Round to avoid floating point precision errors
    const roundedValue = Number(i.toFixed(decimals));
    this.numberList.push(roundedValue);
  }
}

  onSlideChange() {
    if (!this.swiperInstance) return;
    const index = this.swiperInstance.realIndex;
    const newValue = this.numberList[index];

    if (newValue !== this._value) {
      this._value = newValue;
      this.valueChange.emit(newValue);
    }
  }

  onSwiperInit(swiper: any) {
    this.swiperInstance = swiper;
    const indexToSlide = this.numberList.findIndex(num => num === this.value);
    const targetIndex = indexToSlide >= 0 ? indexToSlide : 0;

    swiper.slideTo(targetIndex, 0);

    if (this.value !== this.numberList[targetIndex]) {
      this._value = this.numberList[targetIndex];
      Promise.resolve().then(() => this.valueChange.emit(this._value)); // async emit
    }
     // add custom mousewheel listener
    swiper.el.addEventListener('wheel', (e: WheelEvent) => {
      e.preventDefault(); // prevent page scroll
      if (e.deltaY > 0) {
        swiper.slideNext(100); // fast slide
      } else {
        swiper.slidePrev(100);
      }
    });
  }
}

